import { render } from "./WorkbenchRunPage.vue?vue&type=template&id=45a7105a"
import script from "./WorkbenchRunPage.vue?vue&type=script&lang=js"
export * from "./WorkbenchRunPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__